import { LanguageType } from "../constants/language-eum";

export interface IBroadcastEvent {
  eventFor: BroadcastEventType;
  clonedState?: Record<string, unknown>;
  value?: unknown;
  isPatientUser?: boolean;
  isDirty?: boolean;
  language?: LanguageType;
  sender?: string;
  isDynamicChartVisible?: boolean;
  isPayerSettingChange?: boolean;
  approvalRequestId?: string;
  timerSeconds?: number;
  isTimerRunning?: boolean;
}

export enum BroadcastEventType {
  LOGIN = 'login',
  LOGOUT = 'logout',
  CONTINUE = 'continue',
  STORE = 'store',
  DIRTY_STATE_UPDATE = 'Dirty State Update',
  DIRTY_STATE_REQUEST = 'Dirty State Request',
  DIRTY_STATE_RESPONSE = 'Dirty State Response',
  LANGUAGE_SYNC = 'Language Sync',
  LANGUAGE_CONFIRMATION_DIALOG = 'Language Confirmation Dialog',
  LANGUAGE_DIALOG_CONFIRMED = 'Language Dialog Confirmed',
  DASHBOARD_SETTING_UPDATE = 'Dashboard Setting Update',
  PAYER_SETTINGS_UPDATE = 'Payer Setting Update',
  SLA_TIMER_PAUSE = 'SLA Timer Pause',
  SLA_TIMER_RESUME = 'SLA Timer Resume',
  SLA_TIMER_SYNC_REQUEST = 'SLA Timer Sync Request',
  SLA_TIMER_SYNC_RESPONSE = 'SLA Timer Sync Response',
}

export enum StoreKeys {
  ALL = 'all',
  PROVIDER = 'provider',
  PAYER = 'payer',
  LOADER = 'loader',
  AUTH = 'auth',
}
